var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-badge',{attrs:{"small":"","color":_vm.getSuspendDataProgressColor(_vm.suspendDataPercentage),"value":_vm.isSuspennDataAboveThreshold},scopedSlots:_vm._u([{key:"badge",fn:function(){return [_c('span',[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-exclamation")])],1)]},proxy:true}])},[_c('v-icon',[_vm._v("mdi-package-variant-closed")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }